import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminAudit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setRows(r.data.audit)); }, []);
  return (
    <div className="p-4 sm:p-8 max-w-5xl mx-auto">
      <h1 className="font-serif text-3xl" style={{ color: "#0B2D59" }}>Audit log</h1>
      <p className="text-sm" style={{ color: "#475569" }}>Every access and change is recorded.</p>
      <div className="p2p-card mt-5 overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr style={{ background: "#F4F8FB", color: "#475569" }}>
              <th className="text-left p-3">Timestamp</th>
              <th className="text-left p-3">Actor</th>
              <th className="text-left p-3">Action</th>
              <th className="text-left p-3 hidden md:table-cell">Target</th>
              <th className="text-left p-3 hidden lg:table-cell">Meta</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t" style={{ borderColor: "#E2EBF1" }}>
                <td className="p-3" style={{ color: "#475569" }}>{new Date(r.ts).toLocaleString()}</td>
                <td className="p-3" style={{ color: "#0B2D59" }}>{r.actor}</td>
                <td className="p-3"><span className="p2p-chip">{r.action}</span></td>
                <td className="p-3 hidden md:table-cell font-mono text-xs" style={{ color: "#475569" }}>{r.target}</td>
                <td className="p-3 hidden lg:table-cell font-mono text-xs" style={{ color: "#475569" }}>{JSON.stringify(r.meta || {})}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan="5" className="p-6 text-center" style={{ color: "#475569" }}>No entries yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
